import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { formatTimestampToDate } from '@/shared/util';

import { calculatePatientAge } from './header.util';
import { HeaderItem } from './header-item.component';

export function StaticItems() {
  const {
    patient,
    radiologistScan: { scanDate },
  } = useStudyGuard();
  const translate = useTranslate();

  return (
    <>
      <HeaderItem
        label={translate('FCT.REPORTING.HEADER.LABELS.DOB') as string}
        value={translate('FCT.REPORTING.HEADER.DOB_PII_ACCESS', {
          age: calculatePatientAge(patient),
          dob: patient?.dob,
        })}
      />

      <HeaderItem
        label={translate('FCT.REPORTING.HEADER.LABELS.SCAN_DATE') as string}
        value={formatTimestampToDate(scanDate)}
      />
    </>
  );
}
